import { websiteConfigurationEnum } from "../enums/websiteConfigurations/websiteConfigurationType.enum";
import { appHttpClient } from "../installations/http/axiosInterfaces";
import { dedupeRequest } from "../installations/http/inFlight";

export const addOrUpdateConfiguration = (data) => {
  return appHttpClient.post(`/WebsiteConfiguration/AddOrUpdate`, data);
};

export const deleteConfiguration = (key) => {
  return appHttpClient.post(`/WebsiteConfiguration/Delete`, {
    params: { key },
  });
};

export const getConfigurationByKey = (key) => {
  // 0016: dedupe StrictMode double-invoke; key on the config key so different keys fetch independently.
  return dedupeRequest(`configByKey:${key}`, () =>
    appHttpClient.get(`/WebsiteConfiguration/GetByKey`, {
      params: { key },
    })
  );
};

export const getAllConfigurations = () => {
  // 0015: dedupe concurrent identical fetches (StrictMode double-mount) into one network request.
  return dedupeRequest("websiteConfiguration:all", () =>
    appHttpClient.get(`/WebsiteConfiguration/List`)
  );
};

export const uploadImage = (type, formData) => {
  return appHttpClient.post(`/WebsiteConfiguration/Upload/${type}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteHomeBanner = (bannerId) => {
  return appHttpClient.post(`/WebsiteConfiguration/Delete/HomeBanner/${bannerId}`);
};

const websiteConfigurationService = {
  addOrUpdateConfiguration,
  deleteConfiguration,
  getConfigurationByKey,
  getAllConfigurations,
  uploadImage,
  deleteHomeBanner,
};

export default websiteConfigurationService;
